import { Route } from 'react-router-dom';

import { RequireRole } from 'contexts';
import { Role } from 'types';

import EditRedelivery from './edit-redelivery';
import NewRedelivery from './new-redelivery';
import { RedeliveryProvider } from './redelivery-context';
import RedeliveryList from './redelivery-list';
import ViewRedelivery from './view-redelivery';

const RedeliveryRoutes = (
  <Route
    path="redeliveries"
    element={
      <RequireRole
        allowedRoles={[
          Role.ADMIN,
          Role.BILLING_ADMIN,
          Role.BOOKING,
          Role.SENIOR_BOOKING,
          Role.ADMIN_CUSTOMER,
          Role.CUSTOMER,
          Role.EXTERNAL
        ]}
      />
    }
  >
    <Route index element={<RedeliveryList />} />
    <Route path=":id">
      <Route element={<RedeliveryProvider />}>
        <Route index element={<ViewRedelivery />} />
      </Route>
      <Route path="edit" element={<RedeliveryProvider />}>
        <Route index element={<EditRedelivery />} />
      </Route>
    </Route>
    <Route path="new" element={<RedeliveryProvider />}>
      <Route index element={<NewRedelivery />} />
    </Route>
  </Route>
);

export default RedeliveryRoutes;
